(() => {
  if (window.fmProductGuideBound) return;
  window.fmProductGuideBound = true;
  document.addEventListener('click', event => {
    const upgrade = event.target.closest('[data-fm-set-upgrade]');
    if (upgrade) {
      const scope = upgrade.closest('product-info');
      const chosen = scope?.querySelector('[data-fm-required-choice] input:checked');
      const url = new URL(upgrade.dataset.setUrl, location.origin);
      if (chosen) {
        url.searchParams.set('fm_size_for', upgrade.dataset.setOption);
        url.searchParams.set('fm_size', chosen.value);
      }
      upgrade.href = url.href;
      return;
    }
    const back = event.target.closest('[data-fm-back-to-size]');
    if (back) {
      const product = document.querySelector('product-info[data-fm-uniform-product]');
      if (product?.fmFocusChoice) { event.preventDefault(); product.fmFocusChoice(); }
      return;
    }
    const link = event.target.closest('[data-fm-size-guide]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    const guide = target?.querySelector('details');
    if (!guide) return;
    event.preventDefault();
    guide.open = true;
    guide.querySelector('summary')?.focus({preventScroll:true});
    guide.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  });
})();

